import {CACHE_KEY_COMMERCIAL_REGISTER} from '@/modules/configuration/contants/commercialRegister';
import {fields} from '@/modules/configuration/contants/commercialRegister.form';
import CommercialRegisterApiService from '@/modules/configuration/services/CommercialRegisterApiService';
import {createFieldsHook} from '@/utils/createFieldsHook';
import {createGetOneHook} from '@/utils/createGetOneHook';

export const useGetOneCommercialRegister = createGetOneHook(CommercialRegisterApiService, 'id', CACHE_KEY_COMMERCIAL_REGISTER);
export const useFields = createFieldsHook('commercialRegister', fields);
